module.exports = __webpack_public_path__ + "img/03-wide.2aac38b1.svg";